import React from 'react';
import * as firebase from 'firebase';
import Paper from 'material-ui/Paper';
import RaisedButton from 'material-ui/RaisedButton';
import PageHeading from '../../components/PageHeading';

import '../App/App.css';

const styles = {
  contentHolder: {
    paddingTop: 35,
  },
}

/**
 * This is shown if the user account is not linked to any client
 */
const SignUpPlaceholder = () => {
  const signOut = () => {
    firebase.auth().signOut();
  }
  return (
    <div className="App">
      <div className="MainContainer">
        <PageHeading title="Sign-up" subtitle="Account activation required"/>
        <Paper className="ContentSpacing" style={styles.contentHolder}>
          <p>
            <strong>Thanks for signing up to The Hub!</strong><br/><br/>
            Our support team has been notified of your login attempt and will activate your account as soon as possible.
            After verification you will receive an automated mail.
          </p>
          <p>
            This can take a couple of hours, depending on your timezone. Please <a href="mailto:sales@screen6.io">
            contact us</a> if you have any questions.
          </p>
          <br/>

          <RaisedButton label="Sign out" onTouchTap={signOut} />
        </Paper>
      </div>
    </div>
  )
}

export default SignUpPlaceholder;



// WEBPACK FOOTER //
// ./src/containers/SignUpPlaceholder/index.jsx